'use client';
import {
  categoryType,
  direction,
  Product,
  productCardType,
  ResponseType,
  serviceType,
  setState,
  shop,
  shopServiceType,
} from '@/commonTypes';
import { PageHero } from '@/components/general/PageHero';
import PageWrapper from '@/components/general/PageWrapper';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import { useSearchParams } from 'next/navigation';
import React, { Fragment, useEffect, useState } from 'react';
// import ProductsHero from './ProductsHero';
import styles from '../styles.module.css';
import InfiniteContent from '@/components/general/InfiniteContent';
import Modal from '@/components/structure/Modal';
import useWindowDimensions from '@/functions/useWindowDimensions';
import { useLayoutContext } from '@/context/LayoutContext';
import Api from '@/api';
import { TRIGGERS } from '@/api/global';
import { useTranslations } from 'next-intl';
import AttributeSection from '../AttributeSection';
import ProductsHero from '../ProductsHero';
import TopMenuSection from '../TopMenuSection';
import ProductsFilters from '../ProductsFilters';
import ProductCard from '../ProductCard';
import ServiceCard from '@/components/pages/service/SingleServiceContent/ServiceCard';
import ShopCard from '@/components/pages/shops/ShopsContent/ShopCard';
// import ServiceCard from '@/components/pages/service/SingleServiceContent/ServiceCard';
// import ShopCard from '@/components/general/ShopCard';
// import ProductsFilters from './ProductsFilters';
// import AttributeSection from './AttributeSection';
// import ProductCard from './ProductCard';
// import TopMenuSection from './TopMenuSection';
interface ContentType {
  pageNumber: number | string;
  setPageNumber: setState<number | string>;
  categoryList?: categoryType[];
  direction?: direction;
  setDirection?: setState<direction>;
  infiniteApi?: any;
  limit: number;
  list?:
    | ResponseType<productCardType>
    | ResponseType<shopServiceType>
    | ResponseType<productCardType>
    | ResponseType<shop>
    | any;
  setList: setState<any>;
  params?: any;
  page?: string | number | null;
  type?: 'products' | 'services' | 'shops';
  initialList?:
    | ResponseType<productCardType>
    | ResponseType<shopServiceType>
    | ResponseType<productCardType>
    | ResponseType<shop>;
  info?: any;
  queryKey?: string;
  path?: string;
  activeCategory?: string;
  showAttSection?: boolean;
}

export default function ProductsServicesContent({
  pageNumber,
  setPageNumber,
  categoryList,
  direction,
  setDirection,
  infiniteApi,
  limit,
  list,
  setList,
  params,
  page,
  type,
  initialList,
  info,
  queryKey = 'category',
  path = '/products',
  activeCategory,
  showAttSection = true,
}: ContentType) {
  const searchParams = useSearchParams();
  const { width } = useWindowDimensions();
  const { trigger, setTrigger } = useLayoutContext();
  const tCommon = useTranslations('common');
  const renderFilters = (className?: string) => (
    <div className={`${styles.filters_col} card ${className}`}>
      <AttributeSection categoryList={categoryList} page={path} queryKey={queryKey} info={info} />
    </div>
  );
  console.log('qqqqqqq====', queryKey);
  return (
    <>
      <PageWrapper>
        <ViewportWrapper className={`w-full`}>
          <PageHero>
            <ProductsHero info={info} />
          </PageHero>
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`section-paper mt-0 py-0`}>
        <ViewportWrapper className={`container`}>
          <TopMenuSection
            setPageNumber={setPageNumber}
            categoryList={categoryList}
            queryKey={queryKey}
            page={path}
          />
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`section-light mt-0 py-0`}>
        <div className={`wrap ${styles.listing_wrap}`}>
          <div className={`${styles.listing_body} ${type == 'shops' && styles.listing_body_shops}`}>
            {showAttSection && renderFilters(styles.desktop)}
            <div>
              {showAttSection ? (
                <ProductsFilters
                  setPageNumber={setPageNumber}
                  count={list?.response_details?.count}
                  direction={direction}
                  setDirection={setDirection}
                  path={path}
                />
              ) : (
                <p className={`${styles.totalCount}`}>
                  <span>{list?.response_details?.count}</span> فروشگاه و مرکز خدماتی
                </p>
              )}
              <div className={`${styles.listing_result}`}>
                <ViewportWrapper>
                  <InfiniteContent
                    page={page}
                    params={params}
                    initialList={initialList}
                    // initialList={{ ...initial, response_details: { count: 20 } }}
                    list={list}
                    setList={setList}
                    limit={limit}
                    pageNumber={pageNumber}
                    setPageNumber={setPageNumber}
                    apiCall={Api.productList}
                    gridClass={`${direction == 'vertical' ? styles.pgrid_3 : styles.pgrid_1}  w-full`}
                    clearButton={true}
                    renderItem={(item, index) => (
                      <Fragment key={index}>
                        {type == 'products' && (
                          <ProductCard item={item} index={index} direction={direction} />
                        )}
                        {type == 'services' && (
                          <ServiceCard item={item} index={index} direction={direction} />
                        )}
                        {type == 'shops' && <ShopCard item={item} index={index} />}
                      </Fragment>
                    )}
                    urlQuery={true}
                  ></InfiniteContent>
                </ViewportWrapper>
              </div>
            </div>
          </div>
        </div>
        {typeof window != 'undefined' &&
          typeof document != 'undefined' &&
          width &&
          width < 941 &&
          trigger == TRIGGERS.PRODUCT_FILTERS && (
            <Modal
              handleShowModal={() => {
                setTrigger('');
              }}
              title={tCommon('filters')}
              modalKey={TRIGGERS.PRODUCT_FILTERS}
              extraContentStyle={`${styles.filterModalContent}`}
            >
              {renderFilters(styles.mobileFilters)}
            </Modal>
          )}
      </PageWrapper>
    </>
  );
}
